import React, { createContext, useContext } from 'react';
import { TypographyProps } from '@mui/material';
import Typography from './CalendarBoxTypography';

interface CalendarBoxContextType {
  cssCalculatedWidth?: number;
  backgroundColor: string;
  viewType?: 'month' | 'day' | 'condensed';
}

const CalendarBoxContext = createContext<CalendarBoxContextType | null>(null);

export const CalendarBoxProvider: React.FC<{
  children: React.ReactNode;
  cssCalculatedWidth?: number;
  backgroundColor: string;
  viewType?: 'month' | 'day' | 'condensed';
}> = ({ children, cssCalculatedWidth, backgroundColor, viewType }) => {
  return (
    <CalendarBoxContext.Provider value={{ cssCalculatedWidth, backgroundColor, viewType }}>
      {children}
    </CalendarBoxContext.Provider>
  );
};

export const CalendarBoxTypography: React.FC<TypographyProps> = ({ children, ...props }) => {
  const context = useContext(CalendarBoxContext);

  if (!context) {
    throw new Error('Typography must be used within a CalendarBoxProvider');
  }

  return (
    <Typography
      cssCalculatedWidth={context.cssCalculatedWidth}
      backgroundColor={context.backgroundColor}
      viewType={context.viewType}
      {...props}>
      {children}
    </Typography>
  );
};
